import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  resolveEventWallTimezone,
  scheduleInputToEventWallMinute,
} from "./eventWallMinuteStrings";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Event-wall minute string → `Dayjs` in the event timezone (for MUI `DateTimePicker` + `timezone`).
 */
export function wallMinuteToDayjsInEventTimezone(
  wallInput: string | undefined,
  eventTimezone: string
): Dayjs | null {
  const wall = wallInput?.trim()
    ? scheduleInputToEventWallMinute(wallInput, eventTimezone)
    : "";
  if (!wall) return null;
  const tz = resolveEventWallTimezone(eventTimezone);
  const d = dayjs.tz(wall.slice(0, 16), tz);
  return d.isValid() ? d : null;
}
